import featureFlagStore from "./featureFlagStore";
import Vue from "vue";
import VueGtag, { event } from "vue-gtag";

const LogType = Object.freeze({
	LOG: "LOG",
	WARN: "WARN",
	ERROR: "ERROR",
});

export class FeatureFlag {
	constructor(context, inject) {
		this.devMode = true;
		this.log("==========================");
		this.context = context;
		this.inject = inject;
		this.log("Feature Flag Plugin Loaded");
		this.log("==========================");
	}
	init(devMode = false) {
		this.devMode = devMode;
		this.inject("featureFlag", this);
		this.context.store.registerModule("featureFlagStore", featureFlagStore);
		this.context.store.dispatch("featureFlagStore/init");
		Vue.use(VueGtag, {
			config: { id: process.env.GOOGLE_ANALYTICS_ID },
		});
	}

	throwError(message, ...args) {
		if (this.devMode) {
			throw new Error(message);
		}
	}

	validate(flags) {
		if (typeof flags !== "object" && !Array.isArray(flags)) {
			this.throwError("Feature Flag is not an object or array");
			return [];
		}

		if (Array.isArray(flags) && flags.length === 0) {
			this.throwError("Feature flag list is empty, nothing to check");
			return [];
		}

		if (!Array.isArray(flags)) {
			flags = [flags];
		}

		let flagsToCheck = [];

		flags.forEach((flag) => {
			const props = Object.keys(flag);

			if (props.length === 0) {
				this.throwError("Feature Flag is empty");
				return;
			} else if (!props.includes("name")) {
				this.throwError("Feature Flag name is missing");
				return;
			}

			let { name, extra_data, override, fallbackBehavior } = flag;

			override = override || false;
			fallbackBehavior = fallbackBehavior || false;
			extra_data = extra_data || {};

			if (!name) {
				this.throwError("Feature Flag name is empty");
				return;
			}

			if (override && Object.keys(extra_data).length === 0) {
				this.throwError("Feature Flag override is enabled but no extra data is provided please provide extra_data");
				return;
			}

			flagsToCheck.push({ name, extra_data, override, fallbackBehavior });
		});
		return flagsToCheck;
	}

	async isEnabled(flags, bypassCache = false) {
		const flagsToCheck = this.validate(flags);
		
		return await this.context.store.dispatch("featureFlagStore/getFlagStatus", {
			flags: flagsToCheck,
			bypassCache,
		});
	}

	createEvent(featureFlagName, options) {
		/*
		options?: {
          event_category?: String,
          event_label?: String,
          value?: Number,
      	}
		*/

		if (options.event_category === undefined) {
			options.event_category = "FeatureFlag";
		}

		event(featureFlagName, options);
	}

	console(message, type, ...args) {
		if (this.devMode) {
			const prefix = `[FeatureFlag][${type}][${new Date().toLocaleString()}] `;
			switch (type) {
				case LogType.LOG:
					console.log(`${prefix} - ${message} ${args}`);
					break;
				case LogType.WARN:
					console.warn(`${prefix} - ${message} ${args}`);
					break;
				case LogType.ERROR:
					console.error(`${prefix} - ${message} ${args}`);
					break;
			}
		}
	}

	log(message, ...args) {
		this.console(message, LogType.LOG, ...args);
	}

	warn(message, ...args) {
		this.console(message, LogType.WARN, ...args);
	}

	error(message, ...args) {
		this.console(message, LogType.ERROR, ...args);
	}
}
